import React, { useEffect, useState } from "react";
import { FormControlLabel, Grid, Switch } from "@material-ui/core";
import { WebcamCard } from "../components/home/WebcamCard";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { RecordingButtons } from "../components/home/RecordingButtons";
import { Button, Paper, Typography, Checkbox } from "@mui/material";
import { VideoTimer } from "../api/VideoTimer";
import { checkCameraPermissions, saveVideo } from "../api/utils/webcam";
import { useVideo } from "../api/VideoProvider";
import { CountdownTimer } from "../components/home/CountdownTimer";
import HelpSnackbar from "../components/utils/HelpSnackbar";
import { CameraPermissionsPrompt } from "../components/home/CameraPermissionsPrompt";
import { pStatus, pDataProvider, pSubmissionType, pRecordTime } from "../utils/parameters";
//import Switch from "react-switch";
import { useSnackbar } from "notistack";
//import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
//import FaceRetouchingOffIcon from "@mui/icons-material/FaceRetouchingOff";
import SelectAllIcon from '@mui/icons-material/SelectAll';
import DeselectIcon from '@mui/icons-material/Deselect';
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import useMediaQuery from "@mui/material/useMediaQuery";
import device from "current-device";
import UndoIcon from "@mui/icons-material/Undo";
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDataProvider } from "../api/DataProvider";  
import Tooltip from '@mui/material/Tooltip';
import { useTour } from "@reactour/tour";
import { stepsRecordVariant } from "../components/tour/TourConfig";
import { useCommProvider } from "../api/CommProvider";
import { WebcamSelection } from "../components/home/WebcamSelection";
import { Recorder } from "../components/stream/RecorderNew";

import { Dialog } from "@material-ui/core";
import { LoadingDialog } from "../components/dialog/LoadingDialog";
import { useTranslation } from "react-i18next";
import { DeviceQueries } from "../components/utils/DeviceQueries";
import { useTimerProvider } from '../api/TimerProvider';

import { useStreamProvider } from "../api/StreamProvider";

import {IconButton } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import "../styles/devices/mob_Home.css";
import "../styles/devices/mob_Collaborator.css";

export function DonateFS() {
  const { t } = useTranslation("global")

  const [mediaBlobUrl, setMediaBlobUrl] = useState("");
  /* Devices */
  const [deviceId, setDeviceId] = useState({});
  /* Contexts */
  const { faceStatus, setFaceStatus, cameraPermissions, setCameraPermissions } = useVideo();
  /* Sign to collaborate */
  const [sign, setSign] = useState(pDataProvider.new_sign);
  /* Snackbar */
  const [snack, setSnack] = useState({ open: false, text: "" });
  const [switchGalibo, setSwitchGalibo] = useState(true);
  const [switchSide, setSwitchSide] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const { comm_getDonateFingerspelling, comm_sendDonateFingerspelling } = useCommProvider();
  const { token_id, currentUser } = useDataProvider();
  const { json_data_lemma, json_data_meaning, json_data_glosses } = useDataProvider();

  const [loading, setLoading] = useState(false);
  const [letterHighlighted, setLetterHighlighted] = useState(-1);

  const [arrCharactersFS, setArrCharactersFS] = useState([]);
  const [fontSizeArrCharactersFS, setFontSizeArrCharactersFS] = useState(40);
  const [customTimerRecorder, setCustomTimerRecorder] = useState({
    'max':  pRecordTime.max,
    'min':  pRecordTime.min,
    'step':  pRecordTime.step,
    'timer': pRecordTime.default
  });

  const [speedValue, setSpeedValue] = useState(400);
  const [letterEffect, setLetterEffect] = useState(false);
  const [showConfig, setShowConfig] = useState(false);


  const { 
    streamMediaBlobUrl, 
    setStreamMediaBlobUrl, 
    getStreamIsRecording, 
    streamInitRecording, 
    streamStartRecording, 
    streamPauseRecording, 
    streamStopRecording 
  } = useStreamProvider();

  const { 
    timer, 
    timerActive, 
    configTimer,
    timerSpeed,
    setTimerSpeed,
    setConfigTimer, 
    stopTimer 
  } = useTimerProvider();

  
  /* MOB - Nav responsiveness */
    const queryMatches = DeviceQueries();

  /* Set initial values every time the Home page is opened */
  useEffect(() => {
    setFaceStatus(pStatus.init);
  }, [setFaceStatus]);


  function toggleGalibo() {
    if (switchGalibo) {
      //enqueueSnackbar("Se ha desactivado la detección facial.", { variant: "warning" });
      enqueueSnackbar("Se ha desactivado la ayuda al encuadre.", { variant: "warning" });
    } else {
      //enqueueSnackbar("Se ha activado la detección facial.", { variant: "success" });
      enqueueSnackbar("Se ha activado la ayuda al encuadre.", { variant: "success" });
    }
    setSwitchGalibo((galibo) => !galibo);
  }

  function toggleSide() {
    setSwitchSide((side) => !side);
  }

  /* Tour */
  function handleOpenTour(steps, initStep) {
    setSteps(steps);
    setCurrentStep(initStep);
    setIsOpen(true);
  }

  // function handleJumpButton() {
  //   const arr_words = ["medico", "doctor", "hospital", "dentista", "cirujano"];
  //   const randomWord = arr_words[Math.floor(Math.random() * arr_words.length)];
  //   const arrCharactersFS = randomWord.toUpperCase().split('');

  //   setArrCharactersFS(arrCharactersFS);
  //   console.log("🚀 ~ handleJumpButton ~ arrCharactersFS:", arrCharactersFS);
  //   const arrCharsSize = arrCharactersFS.length
    
  //   if (arrCharactersFS.length > 10){
  //     const extraChars = arrCharsSize - 10;
  //     const newFontSize = 40 - extraChars * 4; // Reduce font size by 2px for each extra character
  //     setFontSizeArrCharactersFS(newFontSize);
  //   }else{
  //     setFontSizeArrCharactersFS(40)
  //   }

  //   let durationRecording = Math.ceil(arrCharsSize / 2);
  //   durationRecording = durationRecording + 1

  //   setCustomTimerRecorder({
  //     'max':  durationRecording + 3,
  //     'min':  durationRecording - 3,
  //     'step':  1,
  //     'timer': durationRecording
  //   })
  // }

    async function getNewSample(response) {
      console.log("🚀 ~ getNewSample ~ getNewSample:", response)
      const lemma = response['lemma']
      console.log("🚀 ~ getNewSample ~ lemma:", lemma)
      const arrChars = lemma.split('');
      console.log("🚀 ~ getNewSample ~ arrChars:", arrChars)
      const arrCharsSize = arrChars.length
      console.log("🚀 ~ getNewSample ~ arrCharsSize:", arrCharsSize)

      setArrCharactersFS(arrChars);

      if (arrCharsSize > 10){
        const extraChars = arrCharsSize - 10;
        const newFontSize = 50 - extraChars * 2; // Reduce font size by 2px for each extra character
        console.log("🚀 ~ getNewSample ~ extraChars:", extraChars)
        console.log("🚀 ~ getNewSample ~ newFontSize:", newFontSize)
        setFontSizeArrCharactersFS(newFontSize);
      }else{
        setFontSizeArrCharactersFS(50)
      }

      // let durationRecording = Math.ceil(arrCharsSize / 2);
      let durationRecording = arrCharsSize + 8

      setCustomTimerRecorder({
        'max':  durationRecording + 5,
        'min':  durationRecording - 5,
        'step':  1,
        'timer': durationRecording
      })

      setLetterHighlighted(-1)
    }

    async function handleRequestNewLemma() {
      setArrCharactersFS([])
      console.log("🚀 ~ handleRequestNewLemma ~ handleRequestNewLemma:", handleRequestNewLemma)
      setStreamMediaBlobUrl(undefined)
      const response = await comm_getDonateFingerspelling(token_id, currentUser);
      console.log("🚀 ~ handleRequestNewLemma ~ response:", response)
      getNewSample(response)
    }
  
    async function handleSend2ServerVideo() {
      setArrCharactersFS([])
      console.log("🚀 ~ handleSend2ServerVideo ~ handleSend2ServerVideo:", handleSend2ServerVideo)
      
      const feedback_word = arrCharactersFS.join('')

      const videoFile = await saveVideo(streamMediaBlobUrl);
      setStreamMediaBlobUrl(undefined)
      
      const response = await comm_getDonateFingerspelling(token_id, currentUser);
      await comm_sendDonateFingerspelling(token_id, currentUser, feedback_word, videoFile);

      console.log("🚀 ~ handleSend2ServerVideo ~ response:", response)
      getNewSample(response)
    };


    useEffect(() => {
      handleRequestNewLemma()
    }, []);

    useEffect(() => {
      console.log("🚀 ~ DonateFS ~ arrCharactersFS:", arrCharactersFS)
    }, [arrCharactersFS]);

    useEffect(() => {
      console.log("🚀 ~ DonateFS ~ timer:", timer)
      console.log("🚀 ~ DonateFS ~ timer:", configTimer)
      let timerLetter = -1
      if (timerActive){
        if (configTimer['label'] === 'Recording'){
          timerLetter = arrCharactersFS.length - (timer - 3)
          console.log("🚀 ~ useEffect ~ DonateFS ~ timer    timerLetter:", timerLetter)
        }
      }
      setLetterHighlighted(timerLetter)

    }, [timer]);

    useEffect(() => {
      console.log("🚀 ~ DonateFS ~ timerSpeed:", timerSpeed)  
    }, [timerSpeed]);

    useEffect(() => {
      console.log("🚀 ~ DonateFS ~ speedValue:", speedValue)
      setTimerSpeed(speedValue/1000)
    }, [speedValue]);


    const increaseSpeed = () => setSpeedValue(speedValue + 100);
    const decreaseSpeed = () => setSpeedValue(speedValue - 100);
    

    const toggleEffectLetter = (event) => {
      setLetterEffect(event.target.checked); // Actualiza el estado con el valor del checkbox
    };

    useEffect(() => {
      console.log("🚀 ~ DonateFS ~ letterEffect:", letterEffect)
    }, [letterEffect]);

      
  

  return (
    <HomeWrapper>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
      <Paper className="sig_SignModal_PaperContent" style={{ width: '800px' }}>
        <div className='sig_SignModal_PaperInfo' style={{height: '120px', border: `5px solid ${timerActive ? 'red' : 'green'}`}}>
          <div className='sig_SignModal_PaperLine' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', padding:'40px' }}>

            <div className="sig_SignModal_PaperTitle" style={{fontWeight: 'bold', fontSize: arrCharactersFS.length > 0 ? 'inherit' : '30px', color: arrCharactersFS.length > 0 ? '#0167b7' : 'inherit'}}>
              {arrCharactersFS.length > 0 ? "Palabra para deletrear:" : "Cargando una nueva palabra..."}
            </div>
            <div className="sig_SignModal_PaperBody" style={{ paddingTop: '5px', height: '80px', fontSize: `${fontSizeArrCharactersFS}px`, display: 'flex', gap: '20px', justifyContent: 'center' }}>
              {arrCharactersFS.map((char, index) => (
                <div 
                  key={index} 
                  style={{ 
                    color: (letterEffect && index === letterHighlighted) ? 'red' : 'inherit', 
                    fontWeight: (letterEffect && index === letterHighlighted) ? 'bold' : 'inherit', 
                    fontSize: (letterEffect && index === letterHighlighted) ? `${fontSizeArrCharactersFS + 20}px` : `${fontSizeArrCharactersFS}px`
                  }}
                >
                  {char}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Paper>
        {(streamMediaBlobUrl === undefined && !timerActive) && (
          arrCharactersFS.length > 0 ? (
            <Button
              data-tour="tourCam_2b"
              onClick={handleRequestNewLemma}
              className="sig_Collab_Terms_ReturnButton sig_Home_ChangeOnDarkMode"
              variant="contained"
              style={{ width: '600px', display: 'flex', justifyContent: 'center', margin: 'auto', marginTop: '-10px', marginBottom: '-40px' }}
            >
              <CancelPresentationIcon className="sig_Collab_UndoIcon" /> SALTAR
            </Button>
          ) : (
            <Button
              data-tour="tourCam_2b"
              onClick={handleRequestNewLemma}
              className="sig_Collab_Terms_ErrorButton sig_Home_ChangeOnDarkMode"
              variant="contained"
              style={{ 
                width: '600px', 
                display: 'flex', 
                justifyContent: 'center', 
                margin: 'auto', 
                marginTop: '-10px', 
                marginBottom: '-40px',
                border: '3px solid #5ea0d4', 
                borderRadius: '8px' // Adjust the value for more or less rounding
              }}
            >
              <WarningAmberIcon className="sig_Collab_UndoIcon" /> EN CASO DE INCIDENCIA, PULSE AQUÍ.
            </Button>
          )
        )}
      </div>

      <Recorder action_send={handleSend2ServerVideo} required_revision={false} customTimer={customTimerRecorder}/>

      {(streamMediaBlobUrl === undefined && !timerActive && showConfig) &&
        <div style={{ backgroundColor: '#5ea0d4', border: '4px solid #2e7eba', display: 'flex', padding: '2px', margin: 'auto', width: '700px', borderRadius: '20px', }}>
          {/* Primer Paper */}
          <Paper
            elevation={3}
            style={{
              margin: "auto",
              alignItems: 'center',
              border: '2px solid red',
              borderRadius: '4px',
              alignContent: 'center',
            }}
          >
            <div style={{ display: 'flex' }}>
              <Typography variant="h6" style={{ padding: '10px', background: 'red', color: 'white', fontWeight: 'bold', marginBottom: '0px' }}>
                Velocidad de signado
              </Typography>
              <Typography variant="h6" style={{ marginLeft: '10px', alignContent: 'center', fontWeight: 'bold' }}>
                {speedValue} ms
              </Typography>
              <IconButton onClick={increaseSpeed}>
                <ArrowUpwardIcon />
              </IconButton>
              <IconButton onClick={decreaseSpeed}>
                <ArrowDownwardIcon />
              </IconButton>
            </div>
          </Paper>
      
          {/* Segundo Paper con RadioButton */}
          <Paper
            elevation={3}
            style={{
              margin: "auto",
              alignItems: 'center',
              border: '2px solid red',
              borderRadius: '4px',
              alignContent: 'center',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" style={{ padding: '10px', background: 'red', color: 'white', fontWeight: 'bold', marginBottom: '0px' }}>
                Efecto Letras
              </Typography>
              <Checkbox
                style={{ marginLeft: '10px', marginRight: '10px', alignContent: 'center' }}
                checked={letterEffect}
                onChange={toggleEffectLetter}
                color="primary"
              />
            </div>
          </Paper>
        </div>
      }

      <Dialog className="sig_SignModal_Dialog" open={loading} maxWidth="md">
        <LoadingDialog />	
      </Dialog>
    </HomeWrapper>
  );
}
